import gql from 'graphql-tag';

const VALIDATE_GOOGLE_OAUTH_CREDENTIALS = gql`
  query validateGoogleOAuthCredentials($name: String!) {
    validateGoogleOAuthCredentials(name: $name) {
      isValid
      email
    }
  }
`;

export default VALIDATE_GOOGLE_OAUTH_CREDENTIALS;
